import {isRegistrySupportedType} from 'constants/RegistryConstants';
import {Batch} from 'constants/SampleConstants';
import {BatchInfo, Bioentity, BioentityInfo} from 'folder-items/FileConstants';
import APIUtil from 'util/APIUtil';

export function isBioentityOrBioentityInfo(
  maybeBioentity: Bioentity | BioentityInfo | Batch | BatchInfo
): maybeBioentity is Bioentity | BioentityInfo {
  if (maybeBioentity.id == null) {
    return false;
  }
  const modelType = APIUtil.apiIdToMaybeType(maybeBioentity.id);
  return modelType != null && isRegistrySupportedType(modelType);
}
